import styles from './layout-login.module.scss';
import {
  Icon,
  IconEnum,
  loginbg,
  loginCustomerBg,
} from '@greenkub-fronts/shared/ui';

import useLayoutLoginFeature from '../../../feature/layout-login-feature/layout-login-feature';
import { ReactElement } from 'react';

interface LayoutLoginProps {
  children: ReactElement;
}

export function LayoutLogin(props: LayoutLoginProps) {
  const { children } = props;

  useLayoutLoginFeature(); // redirection si déjà connecté

  const isCustomer =
    import.meta.env.VITE_CUSTOMER_AREA_URL ===
    import.meta.env.VITE_CURRENT_FRONT_URL;

  return (
    <div
      className={styles['LayoutLogin']}
      style={{
        backgroundColor: 'white',
        backgroundImage: `url(${isCustomer ? loginCustomerBg : loginbg})`,
        backgroundPosition: 'center',
      }}
    >
      <div className={styles['LoginContainer']}>
        <div className={styles['LoginCard']} style={{ height: 'fit-content' }}>
          <Icon name={IconEnum.LOGO} className={styles['LoginLogo']} />
          <span className={styles['LoginText']}>
            {isCustomer
              ? 'Bienvenue dans votre espace client Greenkub'
              : 'Bienvenue sur votre CRM Greenkub'}
          </span>
          {children}
        </div>
      </div>
    </div>
  );
}

export default LayoutLogin;
